import { Table } from "@/components/common/Table";
import prisma from "@/helper/client";
import { getBundesligaTeamRankingForGameday } from "@/helper/getRanksForGameday";
import { LeagueTeam } from "@/models/LeagueTeam";
import { Season } from "@/models/Season";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export async function getServerSideProps(context: any) {
  const { res } = context;
  res.setHeader(
    "Cache-Control",
    "public, max-age=300, stale-while-revalidate=360"
  );

  if (!context.query.season) {
    return {
      redirect: {
        destination: "/bundesliga/table",
        permanent: false,
      },
    };
  }

  const [start, end] = context.query.season.split("-");
  const gamedayIndex = parseInt(context.query.gameday);

  const season = await prisma.season.findFirst({
    where: { startYear: parseInt(start), endYear: parseInt(end) },
    include: { bundesliga: true },
  });

  const gameday = await prisma.gameday.findFirst({
    where: { index: gamedayIndex, leagueId: season?.bundesliga?.id },
  });

  if (!season || !gameday) {
    return {
      redirect: {
        destination: "/bundesliga/table",
        permanent: false,
      },
    };
  }

  const teams = await getBundesligaTeamRankingForGameday(gameday);

  return {
    props: {
      teams,
      selectedSeason: season,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface PageProps {
  teams: LeagueTeam[];
  selectedSeason: Season;
}

export default function Page({ teams, selectedSeason }: PageProps) {
  return <Table teams={teams} season={selectedSeason} />;
}
